import { Tabs } from "antd";
import styled from "styled-components";

export const StyledAppTabs = styled(Tabs)`
  padding: 0px;
  font-size: 16px;
  font-weight: 600;
  .ant-tabs-nav::before {
    border: none;
  }
  .ant-tabs-ink-bar {
    background-color: transparent;
  }
  .ant-tabs-tab {
    padding: 8px 16px;
    border-radius: 8px;
    margin-left: 0px !important;
    margin-bottom: 2px !important;
    background: ${({ theme }) => theme.palette.background.paper};

  }
  .atn-tabs-tab-btn {
    color: ${({ theme }) => theme.palette.text.primary} !important;
  }
  .ant-tabs-tab-active {
    background: ${({ theme }) => theme.palette.background.paper};
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06),
      0px 1px 3px 0px rgba(16, 24, 40, 0.1) !important;
  }
  .ant-tabs-nav-operations {
    display: none !important;
  }
  .ant-tabs-nav-list {
    gap: 8px;
  }
`;
